// mui
import { Box, LinearProgress, styled } from '@mui/material';
import { ButtonIcon, CustomIcon } from 'components/mrp/mrp.styles';

export const Container = styled(Box)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  zIndex: theme.zIndex.appBar,
  width: `calc(100% - ${theme.spacing(4)})`,
  height: '50px',
  padding: theme.spacing(0, 2),

  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: -10,
    left: 0,
    width: '100%',
    height: '10px',
    backgroundColor: theme.palette.background.paper
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    zIndex: -1,
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    borderTopRightRadius: theme.vars.shape.borderRadius,
    borderTopLeftRadius: theme.vars.shape.borderRadius,
    boxShadow: `0 1px 0 0 ${theme.vars.palette.background.default}, ${theme.shadows[1]}, 40px -40px 0 40px ${theme.vars.palette.background.default}`
  }
}));

export const HeaderContentContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '50px'
});

export const ActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  whiteSpace: 'nowrap',
  gap: theme.spacing(2)
}));

export const IconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(4)
}));

export const LabelContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  width: '100%',
  maxWidth: 'calc(100% - 80px)',
  minWidth: 0,
  gap: theme.spacing(1)
}));

export const CalendarHeaderIcon = styled(CustomIcon)(({ theme }) => ({
  color: theme.vars.palette.primary.main,
  width: '32px',
  height: '32px'
}));

export const CalendarHeaderButtonIcon = styled(ButtonIcon)(({ theme }) => ({
  color: theme.vars.palette.text.secondary
}));

export const PanelHeaderIcon = styled(CustomIcon)(({ theme }) => ({
  color: theme.vars.palette.primary.main,
  width: '32px',
  height: '32px'
}));

export const ProgressBarContainer = styled(Box, {
  shouldForwardProp: (propName) => propName != 'isVisible'
})<{ isVisible?: boolean }>(({ isVisible }) => ({
  position: 'relative',
  zIndex: 2,
  visibility: isVisible ? 'visible' : 'hidden'
}));

export const SlimLinearProgress = styled(LinearProgress)({
  height: '2px'
});

export const ContentContainer = styled(Box)({
  width: '100%',
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column'
});

export const EntitySubLabel = styled(Box)({
  width: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});
